<div class="w-full" [formGroup]="formGroup()">
  <div class="flex flex-col w-full">
    <!-- Owner adress   -->
    <div class="flex flex-row items-center gap-8 mb-4">
        <p-floatlabel variant="in">
            <p-select class="w-64" formControlName="countryId" id="animal-country-id" optionLabel="name" optionValue="id" [options]="countries"(onChange)="changeCountry($event)" />
            <label for="animal-country-id">{{ "chipRegistration.owner.countryLabel" | translate }}</label>
        </p-floatlabel>

        <p-floatlabel variant="in">
            <p-select class="w-64" formControlName="regionId" id="animal-region-id" optionLabel="name" optionValue="id" [options]="regions" (onChange)="changeRegion($event)" />
            <label for="animal-region-id">{{ "chipRegistration.owner.regionLabel" | translate }}</label>
        </p-floatlabel>

        <p-floatlabel variant="in">
            <p-select class="w-64" formControlName="settlementId" id="animal-settlement-id" optionLabel="name" optionValue="id" [options]="settlements" />
            <label for="animal-settlement-id">{{ "chipRegistration.owner.settlementLabel" | translate }}</label>
        </p-floatlabel>
    </div>

    <div class="flex flex-row items-center gap-8">
        <p-floatlabel variant="in">
            <input class="w-64" formControlName="address" id="address" pInputText type="text" />
            <label for="address">{{ "chipRegistration.owner.address" | translate }}</label>
        </p-floatlabel>
        <p-floatlabel variant="in">
            <input class="w-64" formControlName="zipCode" id="zipCode" pInputText type="text" />
            <label for="zipCode">{{ "chipRegistration.owner.zipCode" | translate }}</label>
        </p-floatlabel>
    </div>
  </div>
</div>
